import {
    featureFlagsRequest,
    featureFlagsRefreshRequest,
    featureFlagsSuccess,
} from 'src/store/feature-flags/feature-flags.actions';
import {
    getEnvFeatureFlagDefaults,
} from 'src/config/featureFlags';
import { resolveFeatureFlags } from 'src/store/feature-flags/feature-flags.utils';
import { fetchAllLaunchDarklyFlags } from 'src/store/feature-flags/launchDarkly.client';

/**
 * Fetch flags from LaunchDarkly using the JS client SDK.
 *
 * @param {Function} getState - Redux getState
 * @returns {Promise<Record<string, unknown>>} Raw LaunchDarkly flag object (LD keys → values)
 */
export const fetchLaunchDarklyFlags = async (getState) =>
    fetchAllLaunchDarklyFlags(getState);

const resolveAndDispatchFeatureFlags = async (dispatch, getState, { isRefresh = false } = {}) => {
    if (isRefresh) {
        dispatch(featureFlagsRefreshRequest());
    } else {
        dispatch(featureFlagsRequest());
    }

    try {
        const launchDarklyFlags = await fetchLaunchDarklyFlags(getState);
        dispatch(featureFlagsSuccess(resolveFeatureFlags(launchDarklyFlags)));
    } catch (error) {
        console.warn('Feature flag sync failed, using env defaults:', error);
        dispatch(featureFlagsSuccess(getEnvFeatureFlagDefaults()));
    }
};

/**
 * Syncs LaunchDarkly with the current Redux identity context and stores
 * resolved flag values. Initial sync blocks navigation until ready;
 * refreshes update values without clearing ready.
 *
 * @param {{ isRefresh?: boolean }} [options]
 */
export const syncFeatureFlagsOperation = ({ isRefresh = false } = {}) => async (dispatch, getState) => {
    const currentFlags = getState().featureFlags;

    if (!isRefresh && currentFlags?.ready && !currentFlags?.loading) {
        return;
    }

    await resolveAndDispatchFeatureFlags(dispatch, getState, { isRefresh });
};

/**
 * @deprecated Use syncFeatureFlagsOperation() for the initial authenticated sync.
 */
export const initializeFeatureFlagsOperation = () => (dispatch) =>
    dispatch(syncFeatureFlagsOperation({ isRefresh: false }));

/**
 * @deprecated Use syncFeatureFlagsOperation({ isRefresh: true }) for context changes.
 */
export const refreshFeatureFlagsOperation = () => (dispatch) =>
    dispatch(syncFeatureFlagsOperation({ isRefresh: true }));
